import { render } from "./AnnouncementsModal.vue?vue&type=template&id=8ecea82c&scoped=true"
import script from "./AnnouncementsModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementsModal.vue?vue&type=script&lang=js"

import "./AnnouncementsModal.vue?vue&type=style&index=0&id=8ecea82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ecea82c"]])

export default __exports__